import { motion } from 'framer-motion';
import { Calendar, Clock, CheckCircle, FileText } from 'lucide-react';

const nextSteps = [
  {
    icon: <Calendar className="w-5 h-5 text-teal-500" />,
    text: "You'll get a calendar invite within the next few minutes.",
  },
  {
    icon: <Clock className="w-5 h-5 text-teal-500" />,
    text: 'Add the session to your calendar so you don\'t miss it.',
  },
  {
    icon: <FileText className="w-5 h-5 text-teal-500" />,
    text: 'Bring a real coaching session transcript or audio if you\'d like to see it analysed live during the demo.',
  },
];

export function WebinarThankYouPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-lg">

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="flex justify-center mb-8"
        >
          <div className="w-16 h-16 bg-teal-500/20 border border-teal-400/30 rounded-full flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-teal-400" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.5 }}
          className="text-center mb-8"
        >
          <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/30 text-teal-300 text-xs font-semibold px-3 py-1.5 rounded-full mb-5 uppercase tracking-wide">
            Session Intelligence™ — Live Launch Webinar
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">You're In.</h1>
          <p className="text-slate-300 text-lg leading-relaxed">
            Your seat is reserved for the Session Intelligence™ Live Launch Webinar on <strong className="text-white">Thursday, 25 June</strong> — <strong className="text-white">10:00 AM EST (Toronto/New York) · 3:00 PM GMT (London)</strong>. Duration: 45 minutes.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="bg-white/5 border border-white/10 rounded-2xl p-7 mb-6"
        >
          <h2 className="text-white font-semibold text-base mb-5">Here's what happens next:</h2>
          <div className="space-y-5">
            {nextSteps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + i * 0.1, duration: 0.4 }}
                className="flex items-start gap-4"
              >
                <div className="mt-0.5 flex-shrink-0">{step.icon}</div>
                <p className="text-slate-300 text-sm leading-relaxed">{step.text}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-2xl p-5"
        >
          <img
            src="/Patrick_Profile_Under_2MB_q95.jpg"
            alt="Patrick Dahdal"
            className="w-12 h-12 rounded-full object-cover border-2 border-teal-400/50 flex-shrink-0"
          />
          <div>
            <p className="text-slate-300 text-sm leading-relaxed">
              See you on Thursday 25 June,
            </p>
            <p className="text-white font-semibold text-sm mt-1">Patrick</p>
            <p className="text-slate-400 text-xs">Founder, Human Potential OS™</p>
          </div>
        </motion.div>

      </div>
    </div>
  );
}
